export const API_CONFIG = {
  // Always use the full URL
  baseURL: 'https://s3.ts1cloud.com/service3',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
  timeout: 30000 // Add timeout to prevent hanging
};